import { FaArrowRight } from "react-icons/fa6"
import Template from "../vacancies/template"
import { PropTypes } from 'prop-types';
import { DecodeHtml } from "../../utils/decodeHtml";
import { retrunAssets } from "../../utils/getAssets";
import { Link } from "react-router-dom";
import ShowProgramData from "./showProgramData";


const ProgramChoice = ({ admission }) => {

    const header3 = admission?.header3
    const description3 = DecodeHtml({ html: admission?.description3?.markup })
    const admissionBox = admission?.admissionBox?.items?.map(item => {
        item = item?.content?.properties
        return {
            title: item?.title,
            applyBtn: item?.applyButton?.items?.map(item => {
                item = item?.content?.properties
                return {
                    label: item?.label,
                    url: item?.link
                }
            })[0],
            description: item?.description,
            links: item?.buttons?.items?.map(link => {
                link = link?.content?.properties
                return {
                    label: link?.label,
                    children: link?.pagePath?.route?.path,
                    url: link?.buttonDownload != null ? retrunAssets(link?.buttonDownload[0]?.url) : ""


                }
            })
        }
    })

    console.log(admissionBox)


    const curve = "/assets/curve-white.svg"
    const choices = [
        {
            title: "UNDERGRADUATE ADMISSIONS",
            description: "All prospective undergraduate students apply through the Marketing & Student Admission Department, regardless of their intended program of study. On the undergraduate admissions site, you can learn more about our application process and available financial assistance.",
            links: [
                "Enroll Via working Experience (APEL)",
                "Malaysian Undergraduate Fees Table",
                'International Undergraduate Fees Table',
                "Scholarship + financial Aid"
            ]
        },
        {
            title: "POSTGRADUATE ADMISSIONS",
            description: "All prospective postgraduate students apply through the Marketing & Student Admission Department, regardless of their intended program of study. On the postgraduate admissions site, you can learn more about our application process and available financial assistance.",
            links: [
                "Enroll Via working Experience (APEL)",
                "Malaysian Postgraduate Fees Table",
                'International Postgraduate Fees Table',
                "Scholarship + financial Aid"
            ]
        }

    ]
    return (
        <div className="relative bg-white flex flex-col">
            <div className="bg-[#f2f3f4] flex flex-col gap-8 items-start justify-center p-4 2xl:py-16 md:px-32 ">
                <h1 className="w-auto   text-4xl font-bold  ">{header3}</h1>
                <p className="text-justify text-slate-800 flex items-center whitespace-pre-line">{description3} <span className="text-[#5DACF1] underline underline-offset-2">WHY UNITEN</span></p>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 w-full">
                    {
                        admissionBox?.map((choice, index) => {
                            return (
                                <Template key={index}>
                                    <div className="grid place-items-center gap-5">
                                        <h1 className="text-4xl font-bold text-center  text-slate-900 uppercase">{choice?.title}</h1>
                                        <a href={choice?.applyBtn?.url} target="_blank" rel="noreferrer" className="px-8 py-4 w-fit bg-red-800 rounded justify-center items-center gap-4 flex">
                                            <span className="text-white text-base font-bold  flex items-center gap-3">{choice?.applyBtn?.label} <FaArrowRight /></span>
                                        </a>
                                        <hr className="border-dashed border-slate-500 border w-full opacity-30" />
                                    </div>
                                    <p key={index} className="text-slate-500 font-normal">{choice?.description}</p>
                                    <hr className="border-dashed border-slate-500 border w-full opacity-30" />
                                    {
                                        choice?.links?.map((link, index) => {
                                            return (
                                                <div key={index} className="flex items-center gap-2 text-blue-700 font-bold  w-full border border-blue-700 p-4 rounded justify-center">
                                                    {
                                                        link?.children !== undefined &&
                                                        (link?.label?.toLowerCase()?.includes("scholarship")
                                                            ?
                                                            <>
                                                                <Link to={link?.children} >{link?.label}</Link>
                                                                <FaArrowRight size={20} />
                                                            </>
                                                            :
                                                            <>
                                                                <ShowProgramData url={link?.children} />
                                                                <FaArrowRight size={20} />
                                                            </>)

                                                    }
                                                    {
                                                        link?.url &&

                                                        <>
                                                            <a href={link?.url} target="_blank" rel="noreferrer">{link?.label}</a>
                                                            <FaArrowRight size={20} />
                                                        </>
                                                    }

                                                </div>
                                            )
                                        })
                                    }

                                </Template>
                            )
                        })
                    }
                </div>
            </div>
            <img src={curve} className="bg-[#f2f3f4]" alt="" />
        </div>
    )
}
ProgramChoice.propTypes = {
    admission: PropTypes.object
}
export default ProgramChoice